"use client";

import { _ as e, b as r } from "./helpers-BtaZ0NTN.js";
import a, { forwardRef as t } from "react";
import { useConnectedRef as m } from "@react-input/core";
import o from "./useMask.js";
var s = ["component", "mask", "replacement", "showMask", "separate", "track", "modify"];
function p(t, p) {
  var c = t.component,
    n = t.mask,
    f = t.replacement,
    i = t.showMask,
    k = t.separate,
    l = t.track,
    u = t.modify,
    d = e(t, s),
    h = o({
      mask: n,
      replacement: f,
      showMask: i,
      separate: k,
      track: l,
      modify: u
    }),
    M = m(h, p);
  return c ? /*#__PURE__*/a.createElement(c, r({
    ref: M
  }, d)) : /*#__PURE__*/a.createElement("input", r({
    ref: M
  }, d));
}
var c = /*#__PURE__*/t(p);
export { c as default };